import { type ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useReadyState } from 'contexts/ReadyStateContext';

interface ProtectedRouteProps {
  children: ReactElement;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { state: authState } = useAuth();
  const { state: readyState } = useReadyState();
  const location = useLocation();

  // Show loading spinner while app is initializing
  if (readyState.isAppInitializing) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!authState.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user has admin role
  if (authState.user?.role !== 'admin') {
    return <Navigate to="/access-denied" replace />;
  }

  return children;
}
